<template>
  <div class="about">
    <v-alert
      icon="mdi-information"
      colored-border
      border="left"
      class="pa-2 my-2 bg-notif"
      color="warning"
      v-if="[5].includes(kVerval)"
    >
      <template v-if="kVerval === 5">
        Yth. Bapak/Ibu Calon Peserta {{ isKasek ? 'Kepala Sekolah' : 'Fasilitator' }} Sekolah Penggerak,
        <br />
        Mohon melakukan perbaikan sesuai informasi tim Verifikasi sebagai berikut:<br />
        <p class="pa-2 my-2 mr-5 white darken-2 subtitle-2">
          <strong v-html="catatanVerval"></strong>
        </p>
      </template>
    </v-alert>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text">Surat Pernyataan Dukungan Dinas Pendidikan / Atasan</h1>
            <div class="subtitle-1 black--text">
              Anda sedang berada di seleksi tahap 2 pendaftaran Program Sekolah Penggerak
            </div>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left px-0">
                      <h3 class="title orange--text">Status</h3>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in items.slice(0, 1)" :key="i">
                    <td class="px-0">
                      <v-row no-gutters class="py-2">
                        <v-col cols="10" md="8">
                          {{ item.title }}
                        </v-col>
                        <v-col cols="2" md="4">
                          <v-icon
                            :color="
                              status[item.status] ? 'success' : contents[item.id]['optional'] ? 'warning' : 'grey'
                            "
                          >
                            {{
                              status[item.status]
                                ? 'mdi-check-circle'
                                : contents[item.id]['optional']
                                ? 'mdi-help-circle'
                                : 'mdi-alert-circle'
                            }}
                          </v-icon>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="mt-5 grey lighten-4 black--text pa-2" style="font-size: 0.8rem; border-radius: 5px">
              <b>Keterangan Status :</b> <br />
              <i class="v-icon notranslate mdi mdi-check-circle theme--light success--text" style="font-size: 1rem" />
              &nbsp;Langkah seleksi sudah selesai<br />
              <i
                class="v-icon notranslate mdi mdi-alert-circle theme--light grey--text grey-lighten-2"
                style="font-size: 1rem"
              />
              &nbsp; Wajib diisi dan belum dilengkapi/diselesaikan
            </div>

            <template>
              <div>
                <v-btn v-if="isAjuan && kVerval !== 5" depressed color="success" class="mt-2" outlined>
                  Berkas Terkirim
                </v-btn>
                <v-btn v-else-if="isAjuan && kVerval === 6" depressed color="success" class="mt-2" outlined>
                  Berkas Telah Disetujui
                </v-btn>
                <v-btn v-else-if="kVerval === 4" depressed color="error" class="mt-2" outlined>
                  Berkas Ditolak
                </v-btn>
                <v-btn v-else depressed color="success" class="mt-2" :disabled="!status.pernyataan" @click="onAjuan">
                  Kirim Berkas
                </v-btn>
              </div>
            </template>
            <template v-if="kVerval <= 3">
              <!-- is_kirim_ci -->
              <v-alert v-if="isAjuan || kVerval === 3" dense text type="info" class="mt-4">
                <template v-if="isAjuan && kVerval !== 3">
                  Anda sudah mengirimkan berkas Anda untuk diproses, Apabila Anda ingin membatalkan pengiriman berkas
                  dan mengubah isian berkas Anda,
                  <a style="font-weight: bold; text-decoration: underline" @click="onBatalAjuan">klik di sini</a>
                </template>
                <template v-else>
                  Berkas Anda sudah dalam proses verifikasi, pantau terus hasil verifikasi di halaman ini.
                </template>
              </v-alert>
              <v-alert v-else dense text type="info" class="mt-4">
                Pastikan Anda melengkapi surat pernyataan dukungan dinas pendidikan / atasan dan klik tombiol Kirim
                Berkas di atas
              </v-alert>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row>
      <v-col cols="12">
        <h1 class="headline py-2 mt-2">
          Daftar Kelengkapan Dokumen
        </h1>
        <v-expansion-panels tile flat v-model="tab">
          <v-expansion-panel>
            <v-expansion-panel-header class="px-4 subtitle-1">
              Dokumen Kelengkapan
            </v-expansion-panel-header>
            <v-divider></v-divider>
            <v-expansion-panel-content class="px-0">
              <template v-for="(item, i) in items">
                <collection-berkases
                  :key="i"
                  :berkas="berkas[item.id]"
                  :valid="isUpload(item.id)"
                  :value="getBerkas(item.id)"
                  :type="item.id"
                  with-action
                  @upload="onUpload(item.id)"
                ></collection-berkases>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <base-modal-full ref="modal" generalError :title="formulir.title" @save="uploadData">
      <component
        labelColor="info"
        ref="formulir"
        role="kasek"
        :title="formulir.title"
        :subtitle="formulir.subtitle"
        :is="formulir.form"
        :max="formulir.max"
        :format="formulir.format"
        :rules="formulir.rules"
        :detail="formulir.detail"
      >
      </component>
    </base-modal-full>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CollectionBerkases from './components/CollectionBerkases';
import FormUnggah from '@components/form/Unggah';
import mixin from './mixin';
export default {
  mixins: [mixin],
  components: { CollectionBerkases, FormUnggah },
  computed: {
    ...mapState('preferensi', {
      ptk: (state) => state.data?.ptk ?? {},
      instruktur: (state) => state.data?.instruktur ?? {},
      peserta: (state) => state.data?.peserta ?? {},
      profil: (state) => state.data ?? {},
    }),

    ...mapState('cv', {
      detail: (state) => state.detail ?? {},
    }),

    isKasek() {
      return this.$isObject(this.peserta);
    },

    type() {
      return this.isKasek ? 'kasek' : 'instruktur';
    },

    profilID() {
      const id = this.peserta?.psp_profil_id ?? this.instruktur?.psp_profil_id;
      return id;
    },

    berkases() {
      return this.$getDeepObj(this, 'detail.psp_profil_berkases.data') || [];
    },

    kVerval() {
      return Number(this.detail?.k_verval_izin ?? 1);
    },

    isAjuan() {
      return this.kVerval > 1;
    },

    mVervalIzin() {
      return {
        kandidat: this.kVerval === 1,
        ajuan: this.kVerval >= 2,
        diproses: this.kVerval === 3,
        ditolak: this.kVerval === 4,
        revisi: this.kVerval === 5,
        setuju: this.kVerval === 6,
      };
    },

    prosesVerval() {
      const listProses = this[this.isKasek ? 'peserta' : 'instruktur']?.psp_profil_proseses ?? [];
      const prosesVerval = listProses.filter((item) => item.k_profil_proses_psp === 20)[0];
      return prosesVerval;
    },

    catatanVerval() {
      const alasan = JSON.parse(this.$getDeepObj(this.prosesVerval, 'catatan') || `[]`);
      return alasan.map((item) => (this.$isObject(item) ? item.value : item)).join('<br/>');
    },
  },
  created() {
    this.fetch({ id: this.profilID, reset: true });
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
